import { Button, DialogActions } from '@mui/material';
import { useVisorDocumentosStore } from 'hooks/useVisorDocumentosStore';
import React from 'react'
import {usePromocionStore} from "../../../../hooks/usePromocionStore";

export const FooterOptions = () => {
  const { openVisorDocumentos, resetAllState } =
    useVisorDocumentosStore();
    const {
        addPromocionSeleccionada,
    } = usePromocionStore();
  return (
    <DialogActions>
      <Button
        variant="outlined"
        color="error"
        type="button"
        onClick={() => {
          openVisorDocumentos(false);
          resetAllState();
            addPromocionSeleccionada(null);
        }}
      >
        Cerrar
      </Button>
    </DialogActions>
  );
}
